import { APISlideAttributes } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const slideNamespace = 'slides';

export const saveSlide = actionCreator<APISlideAttributes>('[slides] SAVE');
